import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__